import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLong = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 8,
	viewBox: "0 0 19 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M-1.56462e-07 4.00009L18 4.00009",
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15 1L18 4L15 7",
		stroke: "currentColor"
	})]
});
export default SvgArrowLong;
